import { Component, Input, OnInit } from '@angular/core';
import { Employee } from '@models/company';
import { TitleType } from '@models/clients';
import { DropdownResult } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { Brokerage, MatterFileType } from '@models/matter';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterDispatch } from '@state/matter';
import { isEqual } from 'lodash';

@Component({
	selector: 'app-edit-broker-side-form',
	templateUrl: './broker-edit-side-form.component.html',
	standalone: false,
})
export class EditBrokerSideFormComponent implements OnInit {
	public brokerage: Brokerage;
	private isClient;
	public loading: boolean;
	public title: string;

	@SelectSnapshot(SelectedMatter.matterFileType) fileType: MatterFileType;

	@SelectSnapshot(SelectedMatter.id) saleId;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private navigationService: NavigationService,
		private matterDispatch: MatterDispatch,
	) {
		const data = this.router.getCurrentNavigation()?.extras?.state;
		if (data) {
			this.brokerage = data.brokerage;
			this.isClient = data.isClient;
		} else {
			this.navigationService.goBack(this.route);
		}
		this.loading = false;
	}

	ngOnInit(): void {
		this.loading = false;
	}

	_onSubmit(event: Employee): void {
		if (event) {
			this.loading = true;
			if (!isEqual(this.brokerage.broker, event)) {
				this.matterDispatch.CreateBroker(
					this.saleId,
					event,
					this.isClient,
					this.brokerage.id,
					this.fileType,
				);
			}
			this.navigationService.goBack(this.route);
		}
	}

	setTitle($event: DropdownResult<{ name: TitleType }>) {
		this.title = $event.result.name;
	}

	onCancel() {
		this.navigationService.goBack(this.route);
	}

	_title() {
		if (this.isClient) {
			return this.fileType === MatterFileType.SALE
				? 'Seller'
				: this.fileType === MatterFileType.PURCHASE
					? 'Buyer'
					: '';
		}

		return this.fileType === MatterFileType.SALE
			? 'Buyer'
			: this.fileType === MatterFileType.PURCHASE
				? 'Seller'
				: '';
	}
}
